/*
* Segment Selector widget
*
* Only required if the user will be defining segments
*/

(function (SG) {
  SG.registerModule('segmentSelector');
  SG.bind('initialize:after', function(graph) {
    _.bindAll(graph, 'setDragBehaviorToZoomIn', 'setDragBehaviorToSelectSegment', 'selectSegmentFromZoom');
    // dom bindings
    $('.sg-on-drag-select-segment').live('click', graph.setDragBehaviorToSelectSegment);
    $('.sg-select-segment').live('click', graph.selectSegmentFromZoom);
  });
  SG.bind('configure', function(graph) {
    _.extend(graph.options, {
      recenterOnSelectSegment: false,
      revertToZoomInAfterSelectSegment: true
    });
  });
  SG.bind('unload_bindings:before', function(graph) {
    // unload our live handlers
    $('.sg-on-drag-select-segment').die('click', graph.setDragBehaviorToSelectSegment);
  });

  _.extend(SG.prototype, {
    setDragBehaviorToSelectSegment: function(e) {
      if(!e || !$(e.target).hasClass("selected")) {
        this.segmentselectedBehavior = 'select_segment';
        $('.sg-on-drag-zoom-in').removeClass('selected');
        $('.sg-on-drag-select-segment').addClass('selected');
        this.unbindFrom(this, 'segmentselected', this._currentDragBehaviorFn);
        this._currentDragBehaviorFn = this.selectSegment;
        this.bindTo(this, 'segmentselected', this._currentDragBehaviorFn);
      }
    },
    selectSegmentFromZoom: function() {
      this.selectSegment(this.zoomedSlice(), true);
    },
    // the other option for drag behavior, aside from zoomToDataSlice
    selectSegment: function(dataSlice, recenterOn) {
      // lock the user into zooming only while there is a selected segment in play
      this.options._extendedSelectionOptions = this.options.extendedSelectionOptions;
      this.options.extendedSelectionOptions = false;
      this.setDragBehaviorToZoomIn();
      if(this.options.revertToZoomInAfterSelectSegment) {
        this.updateZoomingTip();
      }

      this.segmentSelector = new SG.SegmentSelector({graph: this, dataSlice: dataSlice});
      if(recenterOn || this.options.recenterOnSelectSegment)
        this.segmentSelector.reCenter();

      var that = this;
      this.bindTo(this, 'segmentselector:unload', function afterUnload() {
        if(that.options.revertToZoomInAfterSelectSegment)
          that.options.extendedSelectionOptions = this.options._extendedSelectionOptions;
        delete this.options._extendedSelectionOptions;
        that.updateZoomingTip();
        delete that.segmentSelector;
        that.unbindFrom(that, 'segmentselector:unload', afterUnload);
      });

      this.trigger("segmentselector:load");
    }
  });

  SG.SegmentSelector = Backbone.View.extend({
    // expected options: graph, dataSlice
    initialize: function() {
      var graph = this.graph = this.options.graph;
      var dataSlice = this.dataSlice = this.options.dataSlice;
      this.hidden = false;
      _.bindAll(this, 'addControlBoundsTest', 'removeControlBoundsTest', 'reposition', 'beginDragResize', 'adjustResize', 'dragResizeMouseOut', 'cancelDragResize', 'completeDragResize', 'cacheLastSelected', 'reCenter', 'updateSelected', 'unload');
      this.throttledUpdateSelected = _.throttle(this.updateSelected, 120);
      var handleAWidth = 2,
          handleBufferWidth = 5;
      this.handleWidth = handleAWidth + handleBufferWidth;
      this.$overlay = $('<div><div class="sg-handle sg-left"><div class="sg-buffer"></div><div class="sg-a"><div class="sg-handle-circle"></div></div></div><div class="sg-segment-selector-middle"></div><div class="sg-handle sg-right"><div class="sg-a"><div class="sg-handle-circle"></div></div><div class="sg-buffer"></div></div></div>')
        .addClass('sg-segment-selector-control')
        .css({zIndex: graph.zIndex(5), position: 'absolute'})
        .offset({top: graph.$canvas.offset().top + graph.plotMargin().top, left: 100})
        .height(graph.plotHeight)
        .mousedown(this.beginDragResize)
        .appendTo(graph.$canvas.parent())
        .find('.sg-segment-selector-middle').height(graph.plotHeight).end()
        .find('.sg-handle')
        .width(this.handleWidth).height(graph.plotHeight)
        .find('.sg-handle-circle').css({zIndex: graph.zIndex(5), top: graph.plotHeight/2 - 7}).end()
        .find('.sg-buffer').width(handleBufferWidth).height(graph.plotHeight).end()
        .find('.sg-a').width(handleAWidth).height(graph.plotHeight).end()
        .end();

      this.selectSlice(dataSlice);
      _.defer(_.bind(function() { this.reposition(); }, this));
      this.overlayBoundsTests = [
        graph.standardBoundsTestFn(this.$overlay.find('.sg-left'), 5),
        graph.standardBoundsTestFn(this.$overlay.find('.sg-right'), 5)
      ]
      // kill the metrics overlay
      graph.defaultMouseOutCleanup();
      this.addControlBoundsTest();
      graph.bindTo(graph, 'render:after', this.reposition);
      graph.bindTo(graph, 'dragselect:begin', this.removeControlBoundsTest);
      graph.bindTo(graph, 'dragselect:end', this.addControlBoundsTest);
      graph.bindTo(graph, 'dataslice:select', this.cacheLastSelected);
      graph.disableMapHighlighting();
    },
    unload: function() {
      var graph = this.graph;
      //if(this.actions.saveSegment) this.actions.closeSaveForm();
      this.removeControlBoundsTest();
      graph.unbindFrom(graph, 'render:after', this.reposition);
      graph.unbindFrom(graph, 'dragselect:begin', this.removeControlBoundsTest);
      graph.unbindFrom(graph, 'dragselect:end', this.addControlBoundsTest);
      graph.unbindFrom(graph, 'dataslice:select', this.cacheLastSelected);
      graph.enableMapHighlighting();
      this.$overlay.remove();
      graph.zoomOut();
      if(!graph.options.revertToZoomInAfterSelectSegment)
        graph.setDragBehaviorToSelectSegment();
      graph.trigger('segmentselector:unload');
    },
    hide: function() {
      this.hidden = true;
    },
    show: function() {
      this.hidden = false;
    },
    reCenter: function() {
      this.graph.zoomToDataSlice(this.dataSlice.buffer(this.graph.xAxisType()));
    },
    // need to keep track of last selected data slice so we can easily prevent
    // triggering the event again if indexes dont change
    cacheLastSelected: function(dataSlice) {
      this.lastSelectedDataSlice = dataSlice;
    },
    addControlBoundsTest: function() {
      _.each(this.overlayBoundsTests, function(overlayBoundsTest) {
        this.graph.addControlBoundsTest(overlayBoundsTest);
      }, this);
    },
    removeControlBoundsTest: function() {
      _.each(this.overlayBoundsTests, function(overlayBoundsTest) {
        this.graph.removeControlBoundsTest(overlayBoundsTest);
      }, this);
    },
    reposition: function() {
      var data = this.dataSlice.data(),
          graph = this.graph,
          offset = graph.$canvas.offset(),
          left = offset.left + Math.round(graph.plotToPixel(data[0][graph.xAxisType()])),
          width = offset.left + Math.round(graph.plotToPixel(data[data.length-1][graph.xAxisType()])) - left;
      var plotLeft = graph.$canvas.offset().left + graph.plotMargin().left,
          plotRight = plotLeft + graph.plotWidth;
      if(left + width < plotLeft || left > plotRight || this.hidden) {
        this.$overlay.hide();
      } else {
        this.$overlay.show();
        if(left + width > plotRight) {
          width = plotRight - left + 1;
          this.$overlay.find('.sg-handle.sg-right').hide();
          this.rightHidden = true;
        } else if(left < plotLeft) {
          width = (left + width) - plotLeft;
          left = plotLeft + this.handleWidth;
          this.$overlay.find('.sg-handle.sg-left').hide();
          this.leftHidden = true;
        } else {
          this.$overlay.find('.sg-handle.sg-right').show();
          this.$overlay.find('.sg-handle.sg-left').show();
          this.rightHidden = false;
          this.leftHidden = false;
        }
        this.$overlay
          .offset({left: left - this.handleWidth,
                   top: offset.top + graph.plotMargin().top})
          .height(graph.plotHeight)
          .find('.sg-segment-selector-middle').width(width).height(graph.plotHeight).end()
          .find('.sg-handle,.sg-buffer,.sg-a').height(graph.plotHeight).end()
          .find('.sg-handle-circle').css({zIndex: graph.zIndex(5), top: graph.plotHeight/2 - 7});
      }
    },
    beginDragResize: function(e) {
      if (e.button !== 0) return;
      var graph = this.graph;
      graph.defaultMouseOutCleanup();
      if(this.dragging) {
        this.endDragResize();
        return;
      }
      // unbind the default stuff
      graph.unbindMouseInteractions();
      // stop blocking mousemove events from firing
      this.removeControlBoundsTest();

      // cancel out any text selections
      document.body.focus();
      // prevent text selection in IE
      document.onselectstart = function () { return false; };

      // prevent stuff on the page from getting selected during drag
      e.preventDefault();
      // alright we're dragging, lets keep track of our state in here
      this.dragging = {
        startX: graph.eventToCanvasCoords(e).x,
        initialOffset: this.$overlay.offset(),
        initialWidth: this.$overlay.width()
      };
      // mode is just from left to right what we're dragging... 1=left, 2=middle, 3=right
      if($(e.target).closest('.sg-handle').hasClass('sg-left')) {
        this.dragging.mode = 1;
      } else if($(e.target).closest('.sg-handle').hasClass('sg-right')) {
        this.dragging.mode = 3;
      } else {
        // for simplicity if a side is hidden... we are just setting middle drags to resizes on the visible side
        if(this.leftHidden) this.dragging.mode = 3;
        else if(this.rightHidden) this.dragging.mode = 1;
        else this.dragging.mode = 2;
      }

      graph.bindTo(graph, 'mousemove', this.adjustResize);
      graph.bindTo(graph, 'mouseout', this.dragResizeMouseOut);
      graph.bindTo(graph, 'verticalmouseout', this.cancelDragResize);
      // have to bind it to body because calling preventDefault on this event prevents mouseup from being triggered by this canvas
      graph.bindTo(graph.$body, 'mouseup', this.completeDragResize);
    },
    adjustResize: function(x) {
      var displacement = this.dragging.startX - x,
          dragging = this.dragging,
          middleWidth = (dragging.initialWidth - this.handleWidth*2),
          graph = this.graph,
          offset = this.graph.$canvas.offset(),
          leftSide = graph.plotMargin().left + offset.left,
          rightSide = leftSide + graph.plotWidth,
          left = dragging.initialOffset.left - displacement;
      if(dragging.mode == 1) {
        // dragging left handle
        if(middleWidth + displacement < 1)
          displacement = 1 - middleWidth;
        middleWidth += displacement;
        this.$overlay.offset({left: left})
          .find('.sg-segment-selector-middle').width(middleWidth);
      } else if(dragging.mode == 2) {
        // dragging from middle
        var width = this.$overlay.width();
        left = dragging.initialOffset.left - displacement + this.handleWidth;
        // bounds for left side
        if(left < leftSide) {
          left = leftSide;
        }
        // bounds for right side
        else if(left + width - this.handleWidth*2 > rightSide) {
          left = rightSide - width + this.handleWidth*2;
        }
        this.$overlay.offset({left: left - this.handleWidth});
      } else {
        // right handle
        if(middleWidth - displacement < 1)
          displacement = middleWidth - 1;
        middleWidth -= displacement;
        this.$overlay.find('.sg-segment-selector-middle').width(middleWidth);
      }

      var isZoomed = this.graph.zoomedIn();
      var leftShouldSnap = !isZoomed && left === leftSide;
      var rightShouldSnap = !isZoomed && left + middleWidth === rightSide;
      // snap
      if(leftShouldSnap && !this.leftSnapped) {
        this.$overlay.find('.sg-handle.sg-left').addClass('sg-snapped');
        this.leftSnapped = true;
      }
      if(rightShouldSnap && !this.rightSnapped) {
        this.$overlay.find('.sg-handle.sg-right').addClass('sg-snapped');
        this.rightSnapped = true;
      }
      // or unsnap
      if(!leftShouldSnap && this.leftSnapped) {
        this.$overlay.find('.sg-handle.sg-left').removeClass('sg-snapped');
        this.leftSnapped = false;
      }
      if(!rightShouldSnap && this.rightSnapped) {
        this.$overlay.find('.sg-handle.sg-right').removeClass('sg-snapped');
        this.rightSnapped = false;
      }

      this.throttledUpdateSelected();
    },
    updateSelected: function() {
      if(!this.dragging) return; //since this is throttled it might be called when the drag is over
      var lastSlice = this.lastSelectedDataSlice,
          dataSlice = this.getUpdatedDataSlice();
      if(!lastSlice || lastSlice.i != dataSlice.i || lastSlice.count != dataSlice.count) {
        this.graph.trigger('dataslice:select', dataSlice, 'only_metrics');
      }
    },
    getUpdatedDataSlice: function() {
      var graph = this.graph,
          $canvasOffset = graph.$canvas.offset(),
          firstX = this.$overlay.offset().left + this.handleWidth - $canvasOffset.left,
          firstI = this.dragging.mode != 3 ? graph.canvasXToDataI(firstX).closestI : this.dataSlice.i,
          lastI = this.dragging.mode == 1 ? this.dataSlice.lastI : this.graph.canvasXToDataI(firstX + this.$overlay.width()-this.handleWidth*2).closestI;
      // we need to select at least one point
      if(lastI == firstI) {
        if(firstI == 0) lastI++;
        else firstI--;
      }
      return graph.dataSlice(firstI, 1+lastI-firstI);
    },
    // if the mouse is off to the left or right, snap the selection there
    dragResizeMouseOut: function(e) {
      var graph = this.graph,
          dragging = this.dragging,
          coords = graph.eventToCanvasCoords(e),
          leftSide = graph.plotMargin().left,
          rightSide = leftSide + graph.plotWidth,
          adjustedX;
      if(dragging.mode == 1 && coords.x <= leftSide) {
        //to pin the selected area to the left, need to make some adjustments for the pos. of the mouse cursor relative to the handle
        adjustedX = leftSide - (dragging.initialOffset.left + this.handleWidth - graph.canvasToPageCoords(dragging.startX));
        this.adjustResize(adjustedX);
      } else if(dragging.mode == 3 && coords.x >= rightSide) {
        adjustedX = rightSide + graph.canvasToPageCoords(dragging.startX) - (dragging.initialOffset.left + dragging.initialWidth - this.handleWidth);
        this.adjustResize(adjustedX);
      }
    },
    endDragResize: function() {
      var graph = this.graph;
      delete this.dragging;
      // undo our text selection prevention for IE
      document.onselectstart = null;
      graph.bindMouseInteractions();
      this.addControlBoundsTest();
      graph.unbindFrom(graph, 'mousemove', this.adjustResize);
      graph.unbindFrom(graph, 'mouseout', this.dragResizeMouseOut);
      graph.unbindFrom(graph, 'verticalmouseout', this.cancelDragResize);
      graph.unbindFrom(graph.$body, 'mouseup', this.completeDragSelect);
    },
    cancelDragResize: function() {
      this.endDragResize();
      // reposition to where the overlay started
      this.reposition();
    },
    selectSlice: function(dataSlice) {
      this.dataSlice = dataSlice;
      this.reposition();
      this.graph.trigger('dataslice:select', dataSlice, 'only_metrics');
    },
    completeDragResize: function(e) {
      var endPosition = this.graph.eventToCanvasCoords(e),
        startX = this.dragging.startX,
        mode = this.dragging.mode,
        displacement = endPosition.x - startX;

      var dataSlice = this.getUpdatedDataSlice();
      this.endDragResize();

      // with a 1 pixel epsilon in the middle section of the selector, call this a pointselected event
      if(Math.abs(displacement) <= 1 && mode === 2) {
        var pointsAround = this.graph.canvasXToDataI(startX);
        this.graph.unbindFrom(this.graph, 'pointselected', this.graph.zoomOutOnClick);
        this.graph.trigger('pointselected', pointsAround);
        this.graph.bindTo(this.graph, 'pointselected', this.graph.zoomOutOnClick);
      } else {
        this.selectSlice(dataSlice);
      }
    }
  });
})(SampleGraph);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.segment_selector.js